<div class="genral-tap">

  <div class="faspinner" *ngIf="loading">
    <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
  </div>



  <section [style.direction]="currentLang=='en'?'ltr':'rtl'" *ngIf="!loading" class="apphome">


<dx-tab-panel #tabPanel [(selectedIndex)]="selectedTabIndex" [swipeEnabled]="false" [loop]="false"
  (selectedIndexChange)="onTabClick($event)">
  <dxi-item title="الرئيسية">
    <!-- <div>
      <div class="flex-all">
        <ng-container *ngFor="let ele of data">
          <div class="card" (click)="getChildren(ele)" [ngClass]="{ 'selected': selectedElement === ele }">
            <div class="icon-home">
              <i class="fa-solid fa-money-check"></i>
            </div>
            <div *ngIf="currentLang=='ar'" class="text-name">{{ele.nameAr}}</div>
            <div *ngIf="currentLang=='en'" class="text-name">{{ele.nameEn}}</div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="itreative">
      <ng-container>
        <ng-container *ngFor="let ele of previousparent">
          <div class="flex-all">
            <ng-container *ngFor="let data of ele.children" class="button childrenButton">
              <div class="card btn" (click)="getChildren(data)">
                <div class="icon-home">
                  <i class="fa-solid fa-money-check"></i>
                </div>
                <div *ngIf="currentLang=='ar'" class="text-name">{{data.nameAr}}</div>
                <div *ngIf="currentLang=='en'" class="text-name">{{data.nameEn}}</div>
              </div>
            </ng-container>
          </div>
          <div class="space"></div>
        </ng-container>
      </ng-container>
    </div> -->


        <div class="navgigation">
          <p [ngClass]="{'active-tap':item.id==selectedBreadcrumb}" dir="ltr" class="breadcrumb-item" (click)="getIdBreadcrumb(item)"
            *ngFor="let item of getBreadcrumb(); let last = last"><i *ngIf="!last"
              class="fa-solid fa-angle-left"></i>{{currentLang=='ar'?item.nameAr:item.nameEn}}</p> <i (click)="backToHome()" class="fa-solid fa-house"></i>
        </div>

        <div class="section-route" *ngIf="previousparent.length>0">
          <button (click)="back()"><i class="fa-solid fa-backward-fast"></i></button>
        </div>



    <div class="flex-cards">
      <div class="card" *ngFor="let item of datanavgiation" (click)="GetChildren(item)">
        <i class="fa-brands fa-slack icon-data-tap"></i>
        <p>{{currentLang=='ar'?item.nameAr:item.nameEn}}</p>
        <button><i class="fa-brands fa-golang"></i></button>
      </div>
    </div>

  </dxi-item>




  <dxi-item title="الاحصائيات" *ngIf="showStatiscs">
    <dx-box direction="row" width="100%" [height]="400">
      <dxi-item class="rect demo-light" [ratio]="1"> <dx-chart id="chart" [dataSource]="invoices">
          <dxi-series argumentField="title" valueField="count" name="الفواتير" type="bar" color="#ffaa66">
          </dxi-series>
        </dx-chart> </dxi-item>
    </dx-box>

    <dx-box direction="row" width="100%" [height]="400">
      <dxi-item class="rect demo-dark" [ratio]="1">
        <dx-pie-chart id="pie" title="مبيعات الفروع" palette="bright" [dataSource]="branshinvoice">
          <dxi-series argumentField="title" valueField="count">
            <dxo-label [visible]="true">
              <dxo-connector [visible]="true" [width]="1"></dxo-connector>
            </dxo-label>
          </dxi-series>
          <dxo-size [width]="500"></dxo-size>
          <dxo-export [enabled]="true"></dxo-export>
        </dx-pie-chart>
      </dxi-item>
      <dxi-item class="rect demo-light" [ratio]="1">
        <dx-pie-chart id="pie" title="مشتريات الفروع" palette="bright" [dataSource]="incomebranshinvoice">
          <dxi-series argumentField="title" valueField="count">
            <dxo-label [visible]="true">
              <dxo-connector [visible]="true" [width]="1"></dxo-connector>
            </dxo-label>
          </dxi-series>
          <dxo-size [width]="500"></dxo-size>
          <dxo-export [enabled]="true"></dxo-export>
        </dx-pie-chart>
      </dxi-item>

    </dx-box>


  </dxi-item>



  <dxi-item title="الاشعارات" *ngIf="showNotifications" style="margin-top: 10px;">
    <!-- <div class="itreative"> -->
      <div class="flex-cards">
        <ng-container *ngFor="let data of invoices">
          <div class="card" (click)="navigate(data)" [ngClass]="{'red-button': data.count > 0}">
              <i class="fa-solid fa-bell  icon-data-tap"></i>
            <p *ngIf="currentLang=='ar'">{{data.title}}</p>
            <p *ngIf="currentLang=='en'">{{data.title}}</p>
            <div class="label">{{data.count}}</div>
          </div>
        </ng-container>
      </div>
      <div class="space"></div>

    <!-- </div> -->

      <div class="flex-cards">
        <ng-container *ngFor="let data of storeStatics">
          <div class="card" (click)="navigatestore(data)" [ngClass]="{'red-button': data.count > 0}">
              <i class="fa-solid fa-bell icon-data-tap"></i>
            <p *ngIf="currentLang=='ar'">{{data.title}}</p>
            <p *ngIf="currentLang=='en'">{{data.title}}</p>
            <div class="label">{{data.count}}</div>
          </div>
        </ng-container>
      </div>
      <div class="space"></div>

  </dxi-item>


  <dxi-item title="البحث عن الاصناف" *ngIf="showSearchItems">
    <app-items-search [loaditems]="loaditems"></app-items-search>
  </dxi-item>

  <dxi-item title="احصائيات cdc" *ngIf="isCdc">
    <app-statistics></app-statistics>
  </dxi-item>

</dx-tab-panel>
  </section>
</div>